import React, {useContext, useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';

import ReactPlayer from 'react-player';
import {Col, Image, message, Modal, Row, Spin} from 'antd';
import {MediaContext} from './MediaContext';
import {findMediaById} from 'services/MediaService';
import {handleError} from 'utils/MessageUtils';
import {MediaType} from 'shared/constants/AppConst';

const MediaDetail = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const mediaContext = useContext(MediaContext);
  const {selectedMediaId, viewing, setViewing, setReloading} = mediaContext;
  const [loading, setLoading] = useState(false);
  const [media, setMedia] = useState(null);

  useEffect(() => {
    if (viewing && selectedMediaId) {
      setLoading(true);
      findMediaById(headers, selectedMediaId)
        .then((res) => {
          setMedia(res.data);
        })
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [selectedMediaId]);

  const onCancel = () => {
    setViewing(false);
    setReloading(true);
  };

  return (
    <Modal
      title={media?.title}
      centered
      visible={viewing && selectedMediaId}
      onCancel={() => onCancel()}
      footer={null}
      destroyOnClose={true}
      width={600}
      bodyStyle={{overflowX: 'scroll'}}>
      <Spin spinning={loading}>
        <Row>
          <Col span={24}>
            {media?.type === MediaType.IMAGE && (
              <Image src={media?.url} width='100%' />
            )}
            {(media?.type === MediaType.AUDIO ||
              media?.type === MediaType.VIDEO) && (
              <ReactPlayer
                controls={true}
                url={
                  media?.contentType
                    ? [{src: media?.url, type: media?.contentType}]
                    : media?.url
                }
                width='100%'
              />
            )}
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export default MediaDetail;
